// extracted by mini-css-extract-plugin
export default {"root":"style_root__-QuQA","icon":"style_icon__RIz+p","selectSelect":"style_selectSelect__jrF7U","img":"style_img__iM8Yz"};